export default __webpack_public_path__ + "static/media/pageloader.2c7e3c1a.svg";